module.exports = __webpack_public_path__ + "static/media/drop_well_outline.880dc498.svg";